import type {THREE} from "../resource/BVH";
import type {StringDictionary} from "../delme_globals";

export class InnenUndAussenSeitenNamen {
    private readonly partnameWithoutSideIndicator: string;

    public constructor(partnameWithoutSideIndicator: string) {
        this.partnameWithoutSideIndicator = partnameWithoutSideIndicator;
    }
    public getInnenSeitenname = () => this.partnameWithoutSideIndicator + "innen";
    public getAussenSeitenname = () => this.partnameWithoutSideIndicator + "aussen";
}


export class TrikotWender {
    public static einmalWendenBitte(partnames:string[], modelObjects:THREE.Mesh[], modelParts:StringDictionary<{mesh:THREE.Mesh}>) {
        const paare = getInnenAussenPaare(partnames);
        paare.forEach(p => TrikotWender.switch(p, modelObjects, modelParts))
    }

    private static  switch(innenAussenPaar: InnenUndAussenSeitenNamen, modelObjects:THREE.Mesh[], modelParts:StringDictionary<{mesh:THREE.Mesh}>) {
        TrikotWender.exchangeModelObjectNames(innenAussenPaar, modelObjects);
        TrikotWender.switchMeshes(innenAussenPaar, modelParts);
    }

    private static exchangeModelObjectNames(innenAussenPaar: InnenUndAussenSeitenNamen, modelObjects:THREE.Mesh[]) {
        const oldInnenObject = modelObjects.find(o => o.name === innenAussenPaar.getInnenSeitenname());
        const oldAussenObject = modelObjects.find(o => o.name === innenAussenPaar.getAussenSeitenname());
        oldInnenObject.name = innenAussenPaar.getAussenSeitenname();
        oldAussenObject.name = innenAussenPaar.getInnenSeitenname();
    }

    private static switchMeshes(innenAussenPaar: InnenUndAussenSeitenNamen, modelParts:StringDictionary<{mesh:THREE.Mesh}>) {
        const parkedMesh = modelParts[innenAussenPaar.getAussenSeitenname()].mesh;
        modelParts[innenAussenPaar.getAussenSeitenname()].mesh = modelParts[innenAussenPaar.getInnenSeitenname()].mesh;
        modelParts[innenAussenPaar.getInnenSeitenname()].mesh = parkedMesh;
    }
}

export function switchPpartMaps(innenAussenPaar: InnenUndAussenSeitenNamen, modelParts:StringDictionary<{ mesh:THREE.Mesh }>) {
    const parkedMap = modelParts[innenAussenPaar.getAussenSeitenname()].mesh.map;
    modelParts[innenAussenPaar.getAussenSeitenname()].mesh.map = modelParts[innenAussenPaar.getInnenSeitenname()].mesh.map;
    modelParts[innenAussenPaar.getInnenSeitenname()].mesh.map = parkedMap;
}

export function getInnenAussenPaare(partnames:string[]): InnenUndAussenSeitenNamen[] {
    const innenSeitenNamen = partnames.filter(pn => pn.match(/.*innen$/));
    if (innenSeitenNamen.length === 0) {
        return [];
    }
    return innenSeitenNamen.reduce((carry: InnenUndAussenSeitenNamen[], partname: string) => {
        if (partnames.find(pn => pn.substring(0, pn.indexOf("aussen")) === partname.substring(0, partname.indexOf("innen"))) !== undefined) {
            carry.push(new InnenUndAussenSeitenNamen(partname.substring(0, partname.indexOf("innen"))));
        }
        return carry;
    }, [])
}
